export const SEMANAS = [1, 2, 3, 4];

export const REFEICOES = [
  { campo: "lancheManha", label: "Lanche da manhã" },
  { campo: "almoco", label: "Almoço" },
  { campo: "lancheTarde", label: "Lanche da tarde" },
];
